import React, { FunctionComponent } from 'react'
import ErrorStore from '../../../stores/ErrorStore'
import { Button } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { observer } from 'mobx-react'
import { useNavigate } from 'react-router-dom';

type PayButton = {
    bookingCode?: string | null
    disabled: boolean
    size?: string
    px?: string
}

const PayButton: FunctionComponent<PayButton> = observer(
    ({ bookingCode, disabled, size, px }) => {
        const { t } = useTranslation();
        const label = t("pay");
        const navigate = useNavigate();

        const buttonDisabled = typeof bookingCode !== 'string' || bookingCode.length <= 0 || disabled;

        function navigateToPayment(bookingCode?: string | null)
        {
            navigate(`/payment/?bookingCode=${bookingCode}`);
        }

        return (
            <Button
                onClick={() => navigateToPayment(bookingCode)}
                disabled={buttonDisabled}
                w="auto"
                px={ px || "50" }
                size={size}
            >
                {label}
            </Button>
        )
    }
)

export default PayButton
